import React, { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AuthService } from '@pw-tech/web-sdk'
import { ThemeProvider } from '@pw-tech/omni-ui'
import { AUTH_CONFIG } from 'web-sdk-config'
import AmbassadorRoutes from 'routes'
import { Loader } from '@corecomponents/ui'
import './App.css'
import { LocationProvider } from '@context/LocationContext'
import { BatchPlusModalProvider } from '@context/BatchPlusContext/BatchPlusContext'
import { Toaster } from 'react-hot-toast'
import { RoutingListner } from '@container/RoutingListener/RoutingListener'

const App = () => {
  const [webSDKInitialize, setWebSDKInitialize] = useState(false)
  useEffect(() => {
    AuthService.getInstance(AUTH_CONFIG)
    setWebSDKInitialize(true)
  }, [])
  return webSDKInitialize ? (
    <LocationProvider>
      <Toaster />
      <ThemeProvider>
        <BatchPlusModalProvider>
          <BrowserRouter>
            <RoutingListner />
            <AmbassadorRoutes />
          </BrowserRouter>
        </BatchPlusModalProvider>
      </ThemeProvider>
    </LocationProvider>
  ) : (
    <div className="w-full h-[100vh] flex justify-center items-center text-center">
      <Loader></Loader>
    </div>
  )
}

export default App
